import { render } from "./Collections.vue?vue&type=template&id=6053267d"
import script from "./Collections.vue?vue&type=script&lang=ts"
export * from "./Collections.vue?vue&type=script&lang=ts"
script.render = render

export default script